import { AppEventPublisher, AgenticChatMentionType } from "src/AppEventPublisher";
import type { MentionItem } from "./mentionSearch";

const MENTION_TYPE_PREFIXES: Array<[prefix: string, mentionType: AgenticChatMentionType]> = [
  ["character::", AgenticChatMentionType.Character],
  ["worldbuilding::", AgenticChatMentionType.Worldbuilding],
  ["document::", AgenticChatMentionType.Document],
  ["outline::", AgenticChatMentionType.Outline],
];

export function publishMentionUsedEvent(mentionId: string) {
  const match = MENTION_TYPE_PREFIXES.find(([prefix]) => mentionId.startsWith(prefix));
  if (!match) {
    return;
  }

  AppEventPublisher.agenticChat.mentionUsed(match[1]);
}

/** Prefer this at call sites that already hold a full {@link MentionItem}. */
export function publishAgenticChatMentionUsedFromItem(item: MentionItem): void {
  publishMentionUsedEvent(item.id);
}
